export interface IEvent {
	/** Date de début de l'événement. */
	startDate: Date;
	/** Date de fin de l'événement. */
	endDate: Date;
	/** Durée de l'évenement. */
	duration?: number;
}